import React from 'react'
import { styled } from '@mui/material/styles'
import { GRAY_COLORS } from 'asterX-UI/colors.constant'

const Root = styled('div')(({ isVertical, gap, rootStyle }) => ({
  display: 'flex',
  flexDirection: isVertical ? 'column' : 'row',
  gap,
  ...rootStyle
}))

const Label = styled('div')(({ labelStyle }) => ({
  textAlign: 'left',
  color: GRAY_COLORS[600],
  fontSize: 12,
  fontWeight: 500,
  lineHeight: '20px',
  ...labelStyle
}))

const Content = styled('div')(({ style }) => ({
  ...style
}))

const FieldInfoNG = ({ label, children, rootStyle = {}, labelStyle = {}, style = {}, isVertical = false, gap = 5 }) => {
  return (
    <Root isVertical={isVertical} gap={gap} rootStyle={rootStyle}>
      <Label labelStyle={labelStyle}>{label}</Label>
      <Content style={style}>{children}</Content>
    </Root>
  )
}

export default FieldInfoNG
